import { Sort } from '@angular/material/sort';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyArchivedModules {
    static readonly type = '[MyArchivedModules] SetMyArchivedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class UnsetMyArchivedModules {
    static readonly type = '[MyArchivedModules] UnsetMyArchivedModules';
}

export class AddMyArchivedModules {
    static readonly type = '[MyArchivedModules] AddMyArchivedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyArchivedModule {
    static readonly type = '[MyArchivedModules] FetchMyArchivedModule';

    constructor(public payload: string) {}
}

export class FetchMyArchivedModules {
    static readonly type = '[MyArchivedModules] FetchMyArchivedModules';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isArchived?: boolean;
            participantId?: string;
            tag?: number[];
        }
    ) {}
}

export class FetchMyArchivedModulesSuccess {
    static readonly type = '[MyArchivedModules] FetchMyArchivedModulesSuccess';
}

export class FetchMyArchivedModulesFailure {
    static readonly type = '[MyArchivedModules] FetchMyArchivedModulesFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyArchivedModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyArchivedModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyArchivedModules] DeselectSelectedModules';
}

export class SearchMyArchivedModules {
    static readonly type = '[MyArchivedModules] SearchMyArchivedModules';

    constructor(public payload: string) {}
}

export class SortMyArchivedModules {
    static readonly type = '[MyArchivedModules] SortMyArchivedModules';

    constructor(public payload: Sort) {}
}
